let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bsMRT")).then(() => parcelRequire('1IJmm'));